import { Button } from '@perch-labs/shrike';
import { Link } from '~/components/link';
import { Title, Description } from '~/components/typography';
import { WEBSITE_URL } from '~/utils/constants';
import { Wrapper } from '../errors/error.util';

export const CsUnavailable = ({
  heading,
  subHeading,
  showButton = true,
  buttonText = 'Explore Website',
  description = '',
  redirectURL = WEBSITE_URL,
  showLogo = true,
  testId = 'screen-Unexpected',
}: {
  heading: string;
  subHeading: string;
  buttonText?: string;
  showButton?: boolean;
  redirectURL?: string;
  description?: string;
  showLogo?: boolean;
  testId?: string;
}) => {
  return (
    <Wrapper testId={testId} showLogo={showLogo}>
      <Title textAlign="center" marginTop="48px">
        {heading}
      </Title>
      <div style={{ width: 'auto', marginLeft: 'auto', marginRight: 'auto' }}>
        <Description textAlign="center" marginTop="24px">
          {subHeading}
        </Description>
      </div>
      <div style={{ width: 'auto', marginLeft: 'auto', marginRight: 'auto' }}>
        <Description textAlign="center" marginTop="24px">
          {description}
        </Description>
      </div>
      {showButton ? (
        <Link
          color="primary"
          openInNewTab={false}
          aria-label="RedirectToWebsite"
          href={redirectURL}
        >
          <Button mode="primary">{buttonText}</Button>
        </Link>
      ) : null}
    </Wrapper>
  );
};
